export const learnButtonStyle = {
  textTransform: "none",
  color: "#ffffff",
  background: "#3671E9",
  borderRadius: "2rem",
  padding: ".7rem 1.5rem",
  ":hover": {
    background: "#3671E9",
    transform: "scale(1.05)",
    transition: ".5s",
  },
};

export const whyWrapper = {
  background: "#0F054C",
  color: "#ffffff",
  padding: "6rem",
};
